import React, { useState, useEffect, useCallback } from 'react';

const About = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const carouselImages = [
    { id: 1, image: "/images/picture_1.png", title: "Interactive Classes", description: "Engaging sessions conducted in BATCHES" },
    { id: 2, image: "/images/picture_2.png", title: "Academic support", description: "Concise notes and practice questions for every topic" },
    { id: 3, image: "/images/picture_3.png", title: "Model Tests", description: "Regular tests to track progress and boost confidence" }
  ];

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
  }, [carouselImages.length]);

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + carouselImages.length) % carouselImages.length);
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 10000);
    return () => clearInterval(interval);
  }, [nextSlide]); // ✅ Now dependency is included safely




  return (
    <section id="about" className="section">
      <div className="container">
        <h2 className="section-title">About</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              <strong>Ms. Gayathri</strong> is a passionate Chemistry educator with over 15 years of combined experience in teaching and the chemical industry. 
              Her early career in the <strong>chemical industry</strong> enriched her with practical insights that now enhance her teaching. For the past decade, 
              she has been associated with reputed schools and has also been offering personalized Chemistry tuitions for CBSE students, 
              where her focus lies in making the subject clear, relatable, and enjoyable.
            </p>
            <p>
              Holding an M.Sc., M.Phil., and B.Ed. in Chemistry, Gayathri has trained hundreds of students every year, 
              inspiring many to develop a genuine love for the subject. Every year, her students achieve exceptional marks, 
              including centum scores, a testament to her effective teaching methods. 
            </p>
            <p>
            Ms. Gayathri was also recognized among <p>
              <a href="https://share.google/expvYXIK8zdnruQa0" target="_blank" rel="noopener noreferrer">
                <strong>Oswal's Top 50 Teachers in India (2023)</strong>
              </a>
            </p> 
            </p>
          </div>
          
          <div className="about-images">
            <div className="carousel-container">
              <div className="carousel">
                {carouselImages.map((image, index) => (
                  <div
                    key={image.id}
                    className={`carousel-slide ${index === currentSlide ? 'active' : ''} ${index < currentSlide ? 'prev' : ''} ${index > currentSlide ? 'next' : ''}`}
                  >
                    <div 
                      className="carousel-image"
                      style={{ 
                        backgroundImage: `url(${image.image})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                      }}
                    >
                      <div className="image-overlay">
                        <div className="image-content">
                          <h4>{image.title}</h4>
                          <p>{image.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              
              {/* Carousel Controls */}
              <button className="carousel-btn prev-btn" onClick={prevSlide}>
                ‹
              </button>
              <button className="carousel-btn next-btn" onClick={nextSlide}>
                ›
              </button>
              
              {/* Carousel Indicators */}
              <div className="carousel-indicators">
                {carouselImages.map((_, index) => (
                  <button
                    key={index}
                    className={`indicator ${index === currentSlide ? 'active' : ''}`}
                    onClick={() => setCurrentSlide(index)}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;